import React from "react";
import _ from "lodash";
import { useDispatch } from "react-redux";
import {
  buildPortfolioTradeTransactions,
  setEarliestPriceDates,
  setPortfoliosConfig,
  validatePortfolio,
} from "../../../../utils";
import {getErrorMessage} from "../../../../../../utils/utils";
import {TRANSACTION_TYPE_VALUES} from "../../../../constants";
import {ModelPortfolioResource, QuestionnairesHandlerResource} from "../../../../../../utils/api";
import {displayErrorSnackBar} from "../../../../../../components/SnackbarProvider/actions";
import {prepareComponentsWithContractNumber} from "../../../../../CustomerDashboard/utils";
import {getPortfolioInstrumentsData} from "./dataUtils";


const extendInstrumentsWithAssetInfo = async (instruments) => {
  let res = await ModelPortfolioResource.infoAssets(instruments.filter(i => i.isin).map(i => i.isin));
  instruments.map((pInstrument) => {
    const instrumentData = res.find((e) => e.isin === pInstrument.isin) || {};
    delete instrumentData.category;
    Object.assign(pInstrument, {...instrumentData});
  });
};

const validatePortfolioTransactions = async (portfolio, dispatch) => {
  for (let transactionType in portfolio.transactions) {
    if ([TRANSACTION_TYPE_VALUES.REBALANCING, TRANSACTION_TYPE_VALUES.PORTFOLIO_BUILDER].includes(transactionType)) continue;

    try {
      if (!portfolio.transactions || _.isEmpty(portfolio.transactions[transactionType])) continue;

      const instruments = getPortfolioInstrumentsData(portfolio.transactions[transactionType]);
      await extendInstrumentsWithAssetInfo(instruments);
    } catch (error) {
      dispatch(displayErrorSnackBar(getErrorMessage(error)));
      console.error('Error during instruments validation.');
      console.error(error);
    }
  }
};

const groupPortfoliosForModelPortfolio = (portfolios) => {
  portfolios.forEach(portfolio => {
    if (portfolio.isModelportfolio) {
      [TRANSACTION_TYPE_VALUES.SAVINGS_PLAN, TRANSACTION_TYPE_VALUES.PAYOUT_PLAN].forEach((transactionKey) => {
        const result = prepareComponentsWithContractNumber(portfolio.data, false, transactionKey);
        if (!_.isEmpty(result)) {
          portfolio.data[transactionKey] = _.flatten(_.flatten(
            Object.values(result).map((mpSavingPlan) => [mpSavingPlan])));
        }
      });
    }
  });
};


/**
 * Hook that handles all data initialization for the combined trade step.
 * - Builds transactions from portfolio data
 * - Validates instruments (extends with asset info)
 * - Fetches defaults
 * - Sets earliest price dates for virtual portfolios
 */
const useDataInitialization = ({
  transactionsQuestion,
  portfolios,
  dataService,
  isVirtual,
  onAnswerChange,
  handlePortfolioChange,
  handlePortfolioSelect,
}) => {
  const dispatch = useDispatch();
  const [defaults, setDefaults] = React.useState({});
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    (async () => {
      let currentPortfolios = portfolios;

      if (!isVirtual) {
        setDefaults(await QuestionnairesHandlerResource.getCombinedTradingDefaults(dataService.customer_id));
      } else {
        let instruments = [];

        currentPortfolios.map(portfolio => {
          for (let transactionType of [TRANSACTION_TYPE_VALUES.BUY, TRANSACTION_TYPE_VALUES.SAVINGS_PLAN]) {
            if (!portfolio.transactions || _.isEmpty(portfolio.transactions[transactionType])) continue;
            instruments = instruments.concat(_.filter(portfolio.transactions[transactionType], i => !i.earliestPrice));
          }
        });

        if (!_.isEmpty(instruments)) {
          await setEarliestPriceDates(instruments, dispatch);
        }
      }

      handlePortfolioSelect(currentPortfolios.find(p => p.autoPortfolioBuilder) || currentPortfolios[0]);

      setLoading(false);
    })();
  }, []);

  return {defaults, setDefaults, loading};
};

export default useDataInitialization;
